
// ------------------------------------------------------------------------
// STATE
// ------------------------------------------------------------------------
const state = {
    activeUrl: '',
    isLoading: false // indicates when e.g. infinite scroll is loading
};


// ------------------------------------------------------------------------
// MUTATIONS
// ------------------------------------------------------------------------
const mutations = {
    setActiveUrl(state, activeUrl) {
        state.activeUrl = activeUrl;
    },
    setLoading(state, isLoading) {
        state.isLoading = isLoading;
    },
};


// ------------------------------------------------------------------------
// ACTIONS
// ------------------------------------------------------------------------
const actions = {

};


// ------------------------------------------------------------------------
// GETTERS
// ------------------------------------------------------------------------
const getters = {

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/StateApp.js